import { initializeApp } from 'firebase/app'
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut as fbSignOut,
  type User,
} from 'firebase/auth'
import { getStorage } from 'firebase/storage'

/**
 * Missing config is reported to the UI rather than thrown: an import-time throw
 * here would take the whole bundle down and leave a blank page with no hint.
 */
export const missingConfig: string[] = []

const required = (key: string): string => {
  const v = import.meta.env[key as keyof ImportMetaEnv] as string | undefined
  if (!v) missingConfig.push(key)
  return v ?? ''
}

export const app = initializeApp({
  apiKey: required('VITE_FIREBASE_API_KEY'),
  authDomain: required('VITE_FIREBASE_AUTH_DOMAIN'),
  projectId: required('VITE_FIREBASE_PROJECT_ID'),
  storageBucket: required('VITE_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: required('VITE_FIREBASE_MESSAGING_SENDER_ID'),
  appId: required('VITE_FIREBASE_APP_ID'),
})

export const auth = getAuth(app)
export const storage = getStorage(app)

// Google's account picker every time. Without it a live Google session signs in
// silently, as whichever account happens to be active, and nobody chose anything.
const google = new GoogleAuthProvider()
google.setCustomParameters({ prompt: 'select_account' })

export const signInWithGoogle = () => signInWithPopup(auth, google)
export const signOut = () => fbSignOut(auth)

/**
 * The backend mirrors the Postgres role into a Firebase custom claim, which is
 * what Storage rules gate on. A token minted before that write does not carry
 * the claim, so `forceRefresh` is mandatory after `GET /me` — otherwise staff
 * hit permission-denied on their first internal page.
 */
export const idToken = (user: User, forceRefresh = false) => user.getIdToken(forceRefresh)
